<template>
  <div>
    <div class="bg-body"/>
    <div>
      <div class="test-head-bg"/>
      <div class="col-md-12 test-head-content">
        <div class="test-header">
          <div class="col-10">
            <div class="test-header-title">Tests</div>
          </div>
          <div class="col-2 test-header-logo"><img src="@/assets/img/logo.png"></div>
        </div>
      </div>
    </div>

    <div v-if="ifAllTestFinished" class="test-info">
      <p><b>Bravo, vous avez effectuées tous les tests !</b></p>
    </div>

    <div v-else class="test-info">
      <p>Vous allez accéder aux tests en ligne <span v-if="textDateLimit !== 'null'">jusqu'au <i>{{ textDateLimit }}.</i></span></p>
      <p>Ces tests ne sont pas un examen. Leur seul but est d’apprécier votre niveau en début de formation afin de <b>pouvoir, si nécessaire, adapter votre parcours ASV à vos besoins</b>. Votre intérêt est donc de <b>les compléter de manière personnelle et sincère</b>.</p>
      <Form v-if="!checkboxAllConfirmed">
        <div class="text-justify offset-1 col-11 pt-4">
          <label>
            <input v-model="checkboxStates.isConfirmed" style="cursor:pointer;" type="checkbox" @change="verifyAllChecked();">
            J'affirme effectuer les tests dans des conditions optimales (dans un endroit au calme, seul(e), sur un ordinateur), et avec une connexion internet stable.
          </label>
          <label>
            <input v-model="checkboxStates.hasAcknowledged" style="cursor:pointer;" type="checkbox" @change="verifyAllChecked();">
            J'ai pris connaissance des conditions générales d'utilisation, et je confirme qu'aucun moyen sera utilisé pour copier le contenu qui est soumis aux droits d'auteurs.
          </label>
          <label>
            <input v-model="checkboxStates.isAttested" style="cursor:pointer;" type="checkbox" @change="verifyAllChecked();">
            J'atteste ne pas utiliser d'outils ou de document qui pourraient m'aider à la réalisation des tests et par conséquent, fausser les résultats.
          </label>
          <div id="submit-checkbox-form" class="text-center pt-5">
            <button class="btn-primary" @click="submitCheckbox($event);">Valider</button>
          </div>
          <div class="text-center pt-3">
            <span id="submit-error-form" class="text-danger d-none">Attention ! Vous devez cocher toutes les cases avant de valider.</span>
          </div>
        </div>
      </Form>
    </div>

    <div v-if="checkboxAllConfirmed && mounted">
      <UserTestIntroduction
          :ifIntroductionFinished='ifIntroductionFinished'
          v-bind:introduction='introduction'
      />
      <UserTestRaisonnement
          :ifArgumentationFinished=ifArgumentationFinished
          :ifCalculsFinished=ifCalculsFinished
          :ifExpressionFinished=ifExpressionFinished
          :ifIntroductionFinished=ifIntroductionFinished
          :ifRaisonnementFinished=ifRaisonnementFinished
          v-bind:introduction=introduction
          v-bind:raisonnement=raisonnement
      />
      <UserTestExpression
          :ifArgumentationFinished='ifArgumentationFinished'
          :ifCalculsFinished='ifCalculsFinished'
          :ifExpressionFinished='ifExpressionFinished'
          :ifIntroductionFinished='ifIntroductionFinished'
          :ifRaisonnementFinished='ifRaisonnementFinished'
          v-bind:expression='expression'
          v-bind:raisonnement='raisonnement'
      />
      <UserTestCalculs
          :calculs='calculs'
          :ifArgumentationFinished='ifArgumentationFinished'
          :ifCalculsFinished='ifCalculsFinished'
          :ifExpressionFinished='ifExpressionFinished'
          :ifIntroductionFinished='ifIntroductionFinished'
          :ifRaisonnementFinished='ifRaisonnementFinished'
          v-bind:expression='expression'
      />
      <UserTestArgumentation
          :argumentation='argumentation'
          :ifArgumentationFinished='ifArgumentationFinished'
          :ifCalculsFinished='ifCalculsFinished'
          :ifExpressionFinished='ifExpressionFinished'
          :ifIntroductionFinished='ifIntroductionFinished'
          :ifRaisonnementFinished='ifRaisonnementFinished'
          v-bind:calculs='calculs'
      />
    </div>

    <div v-if="ifAllTestFinished" class="form-group">
      <button :disabled="isDisabled" class="btn btn-primary btn-block" @click="send">
                <span
                    v-show="loading"
                    class="spinner-border spinner-border-sm"
                ></span>
        Envoyer mes tests
      </button>
    </div>
  </div>
</template>

<script>

import UserTestIntroduction from '@/components/UserTest/Introduction.vue'
import UserTestExpression from '@/components/UserTest/Expression.vue'
import UserTestRaisonnement from '@/components/UserTest/Raisonnement.vue'
import UserTestCalculs from '@/components/UserTest/Calculs.vue'
import UserTestArgumentation from '@/components/UserTest/Argumentation.vue'

import UserService from "@/services/user.service";

import {Form} from "vee-validate";

export default {
  name: "Test",
  components: {
    Form,
    UserTestIntroduction,
    UserTestExpression,
    UserTestRaisonnement,
    UserTestCalculs,
    UserTestArgumentation
  },
  computed: {
    isDisabled: function () {
      return this.loading;
    },
  },
  data() {
    let dataCheckbox = JSON.parse(localStorage.getItem('checkboxAllConfirmed'));

    if (dataCheckbox === null) {
      dataCheckbox = false;
    }

    let textDateLimitTest = localStorage.getItem('textLimitTest');

    return {
      loading: false,
      mounted: false,

      introduction: null,
      expression: null,
      raisonnement: null,
      calculs: null,
      argumentation: null,
      thirdTime: false,

      ifIntroductionFinished: false,
      ifExpressionFinished: false,
      ifRaisonnementFinished: false,
      ifCalculsFinished: false,
      ifArgumentationFinished: false,

      ifAllTestFinished: false,
      ifTestSend: false,
      checkboxAllConfirmed: dataCheckbox,
      checkboxStates: {
        isConfirmed: false,
        hasAcknowledged: false,
        isAttested: false
      },
      isModalConfirmVisible: false,
      textDateLimit: textDateLimitTest,
    }
  },
  mounted() {
    UserService.getUserTestContent().then(
        (response) => {
          if (response.data.iftestsend) this.$router.push({name: 'dashboard'});
          this.introduction = response.data.introduction
          this.expression = response.data.expression
          this.raisonnement = response.data.raisonnement
          this.calculs = response.data.calculsprofessionnels
          this.argumentation = response.data.argumentationecrite
          this.thirdTime = response.data.thirdtime

          localStorage.setItem('thirdTime', JSON.stringify(this.thirdTime));

          this.ifIntroductionFinished = this.ifFinished(this.introduction)
          this.ifExpressionFinished = this.ifFinished(this.expression)
          this.ifRaisonnementFinished = this.ifFinished(this.raisonnement)
          this.ifCalculsFinished = this.ifFinished(this.calculs)
          this.ifArgumentationFinished = this.ifFinished(this.argumentation)

          if (this.ifIntroductionFinished && this.ifExpressionFinished && this.ifRaisonnementFinished && this.ifCalculsFinished && this.ifArgumentationFinished) {
            this.ifAllTestFinished = true
          }
          this.mounted = true;
        },
        (error) => {
          this.content =
              (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
              error.message ||
              error.toString();
        }
    );

    var timestampLimitTest = JSON.parse(localStorage.getItem('limitTest'));
    this.finishTests(timestampLimitTest);
  },
  methods: {
    ifFinished: function (userTest) {
      if (userTest == null) return false
      if (userTest.terminatedByUserAt == null && userTest.remainingTime > 0) return false
      return true
    },
    reset: function (event) {
      var id = null
      switch (event.currentTarget.id) {
        case 'introduction':
          id = this.introduction.id;
          break
        case 'expression':
          id = this.expression.id;
          break
        case 'raisonnement':
          id = this.raisonnement.id;
          break
        case 'calculs':
          id = this.calculs.id;
          break
        case 'argumentation':
          id = this.argumentation.id;
          break
      }

      event.currentTarget.classList.toggle('test-section-content-reset-rotate')
      UserService.resetQuestionnaire(id).then(
          setTimeout(function (router) {
            router.go()
          }, 1000, this.$router)
      )
    },
    send() {
      this.loading = true;
      UserService.sendQuestionnaire().then(
          (response) => {
            this.$router.push({name: 'dashboard'});
          },
          (error) => {
            this.loading = false;
            alert(error.response.data.detail)
          }
      );
    },
    verifyAllChecked() {
      if (this.checkboxStates.isConfirmed && this.checkboxStates.hasAcknowledged && this.checkboxStates.isAttested) {
        document.getElementById('submit-error-form').classList.add("d-none");
      }
    },
    submitCheckbox(event) {
      if (this.checkboxStates.isConfirmed && this.checkboxStates.hasAcknowledged && this.checkboxStates.isAttested) {
        this.checkboxAllConfirmed = true;
        localStorage.setItem('checkboxAllConfirmed', JSON.stringify(this.checkboxAllConfirmed));
      } else {
        document.getElementById('submit-error-form').classList.remove("d-none");
        if (event) {
          event.preventDefault();
        }
      }
    },
    finishTests(timestamp) {
      const currentTime = Math.floor(new Date().getTime() / 1000);

      let timeDifference = timestamp - currentTime;
      if (timeDifference < 0) {
        UserService.sendQuestionnaire().then(
            (response) => {
              this.$router.push({name: 'dashboard'});
            },
            (error) => {
              this.loading = false;
              alert(error.response.data.detail)
            }
        );
      }
    }
  },
};
</script>
